import { CollapsiblePanel } from "cai-fusion";
import { FormField } from "../../common/formFields";

// Utility functions for model parameters
const getParameterName = (param) => param?.name ?? param?.modelParameterInstance?.name;
const getParameterDescription = (param) => param?.description ?? param?.modelParameterInstance?.description;

const getMinValue = (param) => param?.modelParameterInstance?.minValue ?? 0;
const getMaxValue = (param) => param?.modelParameterInstance?.maxValue ?? 50000;

const calculateStep = (minValue, maxValue) => {
    if (maxValue === 1) return 0.01;
    if (maxValue === 2) return 0.1;
    if (maxValue === 10) return 0.5;
    if (maxValue >= 10) return Math.floor((maxValue - minValue) / 100);
    return 1;
};

// Separate component for model parameter slider
const ModelParameterSlider = ({ param, updateModelParameters }) => {
    const name = getParameterName(param);
    const description = getParameterDescription(param);
    const minValue = getMinValue(param);
    const maxValue = getMaxValue(param);
    const step = calculateStep(minValue, maxValue);

    return (
        <div className="m-form-group">
            <label htmlFor={name} className="a-label">
                {name}: {param.value}
            </label>
            <input
                id={name}
                type="range"
                className="a-text-input"
                onChange={(e) => updateModelParameters(param.modelParameterId, param.modelId, e.target.value)}
                step={step}
                min={minValue}
                max={maxValue}
                value={param.value}
            />
            <p className="a-muted-text a-subtle-text">
                {description}
            </p>
        </div>
    );
};

const AdvancedSettings = ({ 
    chatTemplate, 
    models, 
    updateData, 
    updateModelParameters 
}) => {
    // Filter parameters for the currently selected model
    const activeModelParameters = chatTemplate?.modelParameters?.filter(
        param => param.modelId === chatTemplate?.modelId && param.modelParameterId !== 5 //max token has css bug, slider does not show
    ) ?? [];

    return (
        <CollapsiblePanel
            label="More nerdy options"
            className="l-mt-xs"
        >
            <div className="row">
                <div className="col-12">
                    <FormField
                        id="customText"
                        label="Custom Instructions"
                        type="textarea"
                        rows={6}
                        value={chatTemplate?.customText}
                        onChange={(e) => updateData(e)}
                        description="You can provide custom instructions that the assistant should use when responding to the user's initial message."
                    />

                    <FormField
                        id="modelId"
                        label="LLM Model"
                        type="select"
                        value={chatTemplate?.modelId}
                        onChange={(e) => updateData(e)}
                        placeholder="Select a model..."
                    >
                        {models?.map((model) => (
                            <option key={model.engine} value={model.engine}>
                                {model.displayName}
                            </option>
                        ))}
                    </FormField>
                    
                    {activeModelParameters.map((param, index) => (
                        <ModelParameterSlider
                            key={param.modelParameterId || index}
                            param={param}
                            updateModelParameters={updateModelParameters}
                        />
                    ))}
                </div>
            </div>
        </CollapsiblePanel>
    );
};

export default AdvancedSettings;